/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useRef, useCallback, useMemo } from "react";
import LogicContext from "../../Context/LogicContext";
import { SetWareHouseList, GetWareHouseList } from "../../store/warehouseAtom";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IoMdRefresh } from "react-icons/io";
import { FaPlus } from "react-icons/fa";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { wareHouseService } from "../../services/warehouse.service";



const WareHouseMainPage = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const { showToast } = useContext(LogicContext);

  const getWarehouseData = GetWareHouseList();
  const setWareHouseData = SetWareHouseList();
  const [tableData, setTableData] = useState([]);
  const [itemSelected, setItemSelected] = useState([]);
  const [searchText, setSearchText] = useState("");

  // Memoized columns
  const columns = useMemo(
    () => [
      {
        title: " Id",
        key: "warehouse_id",
        dataIndex: "warehouse_id",
        className: "text-blue-600 font-medium",
        sorter: (a, b) => (a?.warehouse_id ?? "").localeCompare(b?.warehouse_id ?? ""),
      },
      {
        title: "Name",
        dataIndex: "warehouse_name",
        sorter: (a, b) => (a?.warehouse_name ?? "").localeCompare(b?.warehouse_name ?? ""),
      },
      {
        title: "Product Name",
        dataIndex: "warehouse_email_address",
        sorter: (a, b) => (a?.warehouse_email_address ?? "").localeCompare(b?.warehouse_email_address ?? ""),
      },
      {
        title: "Contact Person",
        dataIndex: "warehouse_contact_person",
        sorter: (a, b) => (a?.warehouse_contact_person ?? "").localeCompare(b?.warehouse_contact_person ?? ""),
      },
      {
        title: "Contact Number",
        dataIndex: "warehouse_contact_number",
        sorter: (a, b) => (a?.warehouse_contact_number ?? "") - (b?.warehouse_contact_number ?? ""),
      },
      {
        title: "Status",
        dataIndex: "warehouse_status",
        sorter: (a, b) => (a?.warehouse_status ?? "") - (b?.warehouse_status ?? ""),
      },
    ],
    []
  );

  // Set table data from global state
  useEffect(() => {
    if (getWarehouseData?.warehouse?.length > 0) {
      setTableData(getWarehouseData?.warehouse);
    } else {
      getStockListFromAPI();
    }
    return () => {
    };
  }, []);

  // Handle session-based reload
  useEffect(() => {
    if (sessionStorage.getItem("reloadPage") === "true") {
      sessionStorage.removeItem("reloadPage");
      getStockListFromAPI();
    }
  }, []);

  // Fetch stock list
  const getStockListFromAPI = useCallback(async () => {
    try {
      const response = await wareHouseService.wareHouseList();
      if ( response?.data !== undefined) {
        setWareHouseData(response.data);
      setTableData(response.data?.warehouse || []);

      }
    } catch (err) {
      console.error(err);
    }
  }, [setWareHouseData]);

  const selectedTableItems = useCallback((itemList) => {
    setItemSelected(itemList);
  }, []);

  const addNewInvoice = useCallback(() => {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
  }, [currModuleId, currModuleName, currUserMenu, navigate]);

  const handleRowClick = useCallback(
    (data) => {
      const id = data["warehouse_id"];
      navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`);
    },
    [currModuleId, currModuleName, currUserMenu, navigate]
  );

  const onClearInput = () => {
    setSearchText("");
    setTableData(getWarehouseData?.warehouse || []);
  };

  const handleSearch = (text) => {
    setSearchText(text);
    if (text.trim() === "") {
      setTableData(getWarehouseData?.warehouse || []);
      return;
    }
    const searchTerm = text.toLowerCase();
    const filtered = (getWarehouseData?.warehouse || []).filter((item) =>
      Object.values(item).some((value) => value?.toString().toLowerCase().includes(searchTerm))
    );
    setTableData(filtered);
  };


  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      {/* Header Section */}
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-6 space-y-4 md:space-y-0">
        <h2 className="text-2xl font-bold text-gray-800">Warehouse List</h2>
        <div className="flex items-center space-x-4">
          {/* Refresh Button */}
          <button
            onClick={getStockListFromAPI}
            className="p-2 rounded-full  shadow-md hover:bg-gray-100 transition-colors"
            title="Refresh"
          >
            {/* <IoMdRefresh className="h-5 w-5 text-gray-600" /> */}
            <IoMdRefresh className="h-[20px] w-[20px] text-gray-600" />



          </button>
          {/* Add New Button */}
          <button
            onClick={addNewInvoice}
            className="px-4 py-2 bg-blue-600 text-white rounded-md shadow-md hover:bg-blue-700 transition-colors flex items-center space-x-2"
          >
            <FaPlus className="h-4 w-4" />
            <span className="text-white" >Add New</span>
          </button>
        </div>
      </div>

      {/* Search Input */}
      <div className="mb-6">
        <input
          type="text"
          placeholder="Search in table..."
          value={searchText}
          onKeyDown={(e) => {
            if (e.key === "Backspace" && searchText === "") {
              onClearInput();
            }
          }}
          onChange={(e) => handleSearch(e.target.value)}
          className="w-full md:w-1/3 px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
        />
      </div>

      {/* Table Section */}
      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        <GeneralCustomTable
          tableHeadList={columns}
          tableDataList={tableData}
          allowCheckBox={true}
          setSelectedRows={selectedTableItems}
          rowKey={(record) => record.item_id} // Updated to use item_id as key
          handleRowClick={handleRowClick}
        />
      </div>
    </div>
  );
};

export default React.memo(WareHouseMainPage);